import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiCommand, FiLayers, FiUsers, FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import '../../styles/topnav.css';

const navItems = [
  { path: '/superadmin/dashboard', label: 'Command Center', icon: <FiCommand /> },
  { path: '/superadmin/portals', label: 'Workspaces', icon: <FiLayers /> },
  { path: '/superadmin/users', label: 'People', icon: <FiUsers /> },
];

export default function SuperAdminLayout() {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    api.get('/superadmin/auth/session').then(({ data }) => {
      if (data.loggedIn) setAdmin(data.admin);
      else navigate('/superadmin/login');
    }).catch(() => navigate('/superadmin/login'))
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = async () => {
    await api.post('/superadmin/auth/logout');
    toast.success('Logged out');
    navigate('/superadmin/login');
  };

  if (loading) return <div className="loading-spinner" style={{ height: '100vh' }}><div className="spinner" /></div>;
  if (!admin) return null;

  return (
    <div className="app-layout topnav-layout">
      <nav className="topnav superadmin-topnav">
        {/* Brand */}
        <div className="topnav-brand" onClick={() => navigate('/superadmin/dashboard')}>
          <img src="/Conquerlogo.png" alt="Logo" className="topnav-logo" />
          <div className="topnav-brand-text">
            <h1>Conquer</h1>
            <span>SUPER ADMIN</span>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="topnav-mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>

        {/* Navigation Menu */}
        <ul className={`topnav-menu ${mobileMenuOpen ? 'open' : ''}`}>
          {navItems.map(item => (
            <li key={item.path} className="topnav-item">
              <NavLink to={item.path} className={({ isActive }) => `topnav-link ${isActive ? 'active' : ''}`}>
                {item.icon}
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Right Section */}
        <div className="topnav-right">
          <div className="topnav-user">
            <div className="topnav-avatar">SA</div>
            <div className="topnav-user-info">
              <span>{admin.username}</span>
              <small>Super Admin</small>
            </div>
          </div>
          <button className="topnav-logout" onClick={handleLogout} title="Logout">
            <FiLogOut />
          </button>
        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
